import Reveal from "@/components/Reveal";
import { Heart, ArrowUpRight } from "lucide-react";

export default function Solidarieta({ data }) {
  return (
    <section id="solidarieta" data-testid="solidarieta-section" className="py-16 sm:py-24 bg-[#F3ECE0]">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-12">
        <Reveal>
          <div className="flex flex-col sm:flex-row items-center gap-8 sm:gap-12 rounded-3xl bg-white border border-[#241C1A]/10 px-6 sm:px-10 py-8 sm:py-10 shadow-sm">
            <div className="relative shrink-0">
              <img
                src={data.image}
                alt={data.alt}
                data-testid="solidarieta-image"
                loading="lazy"
                className="w-44 sm:w-56 aspect-square object-cover rounded-full border-4 border-[#FAF7F2] shadow-xl shadow-[#1E1614]/15"
              />
              <span className="absolute -top-1 -right-1 w-11 h-11 rounded-full bg-[#C86D51] text-[#FAF7F2] flex items-center justify-center shadow-lg">
                <Heart size={19} fill="currentColor" />
              </span>
            </div>
            <div className="text-center sm:text-left">
              <p className="font-accent text-xs uppercase tracking-[0.25em] text-[#506334] mb-3">
                {data.tag}
              </p>
              <h2 className="font-display tracking-tight text-2xl sm:text-3xl lg:text-4xl text-[#241C1A] leading-[1.15]">
                {data.title}
              </h2>
              <p className="mt-4 text-base leading-relaxed text-[#6E625E] max-w-xl">{data.text}</p>
              <a
                href={data.link_url}
                target="_blank"
                rel="noopener noreferrer"
                data-testid="solidarieta-link"
                className="mt-6 inline-flex items-center gap-2 rounded-full bg-[#C86D51] text-[#FAF7F2] px-6 py-3 text-sm font-medium hover:bg-[#A84C32] transition-colors duration-300"
              >
                {data.link_label} <ArrowUpRight size={16} />
              </a>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
